import { render } from "./IconTrashCan.vue?vue&type=template&id=6a07f600&ts=true"
import script from "./IconTrashCan.vue?vue&type=script&lang=ts"
export * from "./IconTrashCan.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__